/*
 * @Author: crazycattle
 * @Date: 2022-01-08 18:00:34
 * @Description: content
 */
module.exports = {
    lang: {
        userLogin:'账号密码登录',
        telLogin:'短信验证码登录',
        plaUser:'请输入账号',
        plaPassword:'请输入密码',
        rememberPassword:'记住密码',
        forgetPassword:'忘记密码？',
        login:'登录',
        reg:'没有账号？立即注册',
        inputCode:'请输入验证码',
        getCode:'获取验证码',
        passwordMsg:'两次输入的密码不一样',
        passwordLang:'密码长度6-20位，支持英文和数字',
        register:'注册',
        wirteData:'完善资料',
        complete:'完成',
        inputTel:'请输入手机号码',
        confirmPassword:'请再次确认密码',
        save:'保存',
        inputCnName:'请输入中文名字',
        inputEnName:'请输入英文名字',
        selectSex:'请选择性别',
        schoolType:'请选择学校类型',
        man:'男',
        women:'女',
        trainSchool:'培训学校',
        kindergarten:'幼儿园',
        selectArea:'请选择省份',
        selectCity:'请选择城市',
        selectSchool:'请选择学校',
        selectBirthday:'请输入生日',
        wirteName:'请填写中英文名称',
        regComplete:'恭喜您，注册成功',
        startStudy:'开始学习',
        thumbs:'点赞',
        collection:'收藏',
        out:'退出',
        meSc:'我的收藏',
        record:'浏览记录',
        playAll:'播放全部',
        audioName:'音频名称',
        videoName:'视频名称',
        myBook:'我的书架',
        personalCenter:'个人中心',
        notData:"暂无数据",
        addBaby:'添加宝宝',
        headerImg:'头像',
        changeHeaderImg:'更换头像',
        cnName:'中文名',
        enName:'英文名',
        sex:'性别',
        birthday:'生日',
        gong:'共',
        shou:'首',
        selectSchoolType:'学校类型',
        schoolArea:'学校所在省份',
        schoolCity:'学校所在市区',
        advanceSelectionArea:'请先选择省份',
        advanceSelectionCity:'请先选择城市',
        schollName:'学校名称',
        delete:'删除',
        notHistory:'暂无历史记录',
        clearHistory:'清除全部记录',
        history:'最近浏览',
        langChange:'繁简切换',
        babyChange:'宝宝切换',
        changePassword:'修改密码',
        notScData:'暂无收藏记录',
        editPersonal:'编辑个人资料',
        tel:'手机号码',
        list:'列表',
        orderPlay:'顺序播放',
        randomPlay:'随机播放',
        singlePlay:'单曲循环',
        cthumbs:'取消点赞',
        ccollection:'取消收藏',
        noBaby:'无法对当前宝宝进行解绑哦~',
        changetext:'已为您自动切换字体，请重新点击登陆按钮',
        telerr:'手机号格式错误',
        jiebang:'申请解绑',
        jiechu:'解除后学生将失去使用的权限, 请确认后在解除绑定哦',
        queren:'确认',
        selectHeaderImg:'选择头像',
        backHome:'返回至首页',
        deletejilu:'此操作将删除该记录, 是否继续?',
        ys:'我已阅读并同意《吉的堡百乐汇隐私政策》',
        yuedu:'请阅读并同意《吉的堡百乐汇隐私政策》',
        jiaoshi:'教师账号',
        loadingStatu:'拼命加载中',
        yanz:'验证密码',
        qiehuan:'切换成功',
        totalTxt1: '共',
        totalTxt2: '首'
    }
}



//////////////////
// WEBPACK FOOTER
// ./static/lang/zh-CN.js
// module id = J71k
// module chunks = 21